import { Components } from 'api/gen/client'
import { tableColumns } from './structure'
import { Table } from 'antd'
import formatAmount from 'shared/helpers/formatAmount'
import resolveInvoiceTotals from 'features/invoices/helpers/resolveInvoiceTotals'

interface InvoiceLinesProps {
  invoice: Components.Schemas.Invoice
}

const InvoiceLinesSummary = ({ total, tax, invoiceLines }: {
  total: string | null
  tax: string | null
  invoiceLines: Components.Schemas.InvoiceLine[]
}) => {
  const resolved = resolveInvoiceTotals(total, tax, invoiceLines)

  return (
    <Table.Summary>
      <Table.Summary.Row>
        <Table.Summary.Cell index={0} colSpan={7} align="right">Total (Excl. Tax)</Table.Summary.Cell>
        <Table.Summary.Cell index={1}>{formatAmount(Number(resolved.subtotal))}</Table.Summary.Cell>
      </Table.Summary.Row>
      <Table.Summary.Row>
        <Table.Summary.Cell index={0} colSpan={7} align="right">VAT Amount</Table.Summary.Cell>
        <Table.Summary.Cell index={1}>{formatAmount(Number(resolved.tax))}</Table.Summary.Cell>
      </Table.Summary.Row>
      <Table.Summary.Row>
        <Table.Summary.Cell index={0} colSpan={7} align="right"><strong>Total (Incl. Tax)</strong></Table.Summary.Cell>
        <Table.Summary.Cell index={1}><strong>{formatAmount(Number(resolved.total))}</strong></Table.Summary.Cell>
      </Table.Summary.Row>
    </Table.Summary>
  )
}

const InvoiceLines = ({ invoice }: InvoiceLinesProps) => {
  return (
    <Table
      dataSource={invoice.invoice_lines}
      columns={tableColumns}
      pagination={false}
      rowKey="id"
      summary={() => (
        <InvoiceLinesSummary total={invoice.total} tax={invoice.tax} invoiceLines={invoice.invoice_lines} />
      )}
    />
  )
}

export default InvoiceLines
